'use client';

import { SvgIcon, SvgIconProps } from '../components';

export const AddFavorite = (props: SvgIconProps) => (
  <SvgIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.90004 11.8833L8.00004 10.6167L10.1 11.9L9.55004 9.5L11.4 7.9L8.96671 7.68333L8.00004 5.41667L7.03337 7.66667L4.60004 7.88333L6.45004 9.5L5.90004 11.8833ZM3.88337 14.6667L4.96671 9.98333L1.33337 6.83333L6.13337 6.41667L8.00004 2L9.86671 6.41667L14.6667 6.83333L11.0334 9.98333L12.1167 14.6667L8.00004 12.1833L3.88337 14.6667Z"
      fill="#5B657E"
    />
  </SvgIcon>
);
